export default "__VITE_ASSET__92964114__"